function dobbleGameImg(conf,resources){
    ////polygon,img_id,pos,scale,rotation_pi
    conf=$.extend(true,{
        img_id:1,
        pos:[],
        scale:100,
        angle_pi:0
    },conf);
    PIXI.Container.call(this);
    this.conf=conf;
    this.resources=resources;
    //cell_back
    this.objImg=new myPixiElement.img({img:"img"+conf.img_id});
    this.objImg.rotation=conf.angle_pi;
    this.objImg.scale.set(conf.scale/100);
    this.x=conf.pos[0];
    this.y=conf.pos[1];
    this.addChild(this.objImg);
}
dobbleGameImg.prototype = Object.create(PIXI.Container.prototype);
dobbleGameImg.prototype= $.extend(dobbleGameImg.prototype,{
    myUpdate:function(delta){
        
    }
});


